import { PointOfInterest } from '../../types';
import api from '../../utils/api';

export const createPointOfInterest = (variables: PointOfInterest) =>
  api.post({
    url: `/point-of-interest`,
    variables,
  });
